import React from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/button';
import { courses } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';

const CourseCard = ({ course, viewCourseText, comingSoonText, courseLink }) => {
  const handleViewCourse = () => {
    if (courseLink) {
      window.open(courseLink, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="bg-[#1a1a2e]/50 rounded-xl overflow-hidden group transition-all duration-300 hover:transform hover:scale-[1.02] hover:shadow-xl hover:shadow-pink-500/10">
      <div className="relative aspect-video overflow-hidden">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
      </div>
      <div className="p-5">
        <h3 className="text-lg font-semibold text-white mb-2 line-clamp-1">{course.title}</h3>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-1">
            <span className="text-gray-400 text-sm">({course.rating})</span>
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 text-yellow-400" fill="#facc15" />
            ))}
          </div>
          {typeof course.price === 'number' && (
            <span className="text-pink-400 font-bold text-lg" data-testid={`course-price-${course.id}`}>
              ${course.price}
            </span>
          )}
        </div>
        <Button
          onClick={handleViewCourse}
          disabled={!courseLink}
          variant="outline"
          className="w-full border-pink-500/50 text-pink-400 hover:bg-pink-500/10 hover:text-pink-300 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
          data-testid={`course-cta-${course.id}`}
        >
          {courseLink ? viewCourseText : comingSoonText}
        </Button>
      </div>
    </div>
  );
};

const CoursesSection = () => {
  const { t } = useLanguage();

  // Real course website links (id 5 "التأملات الالماسية" is Coming Soon)
  const courseLinks = {
    1: 'https://dna-healthy-nutrition.com',
    2: 'https://nawwafalshibli.thinkific.com/courses/awareness1',
    3: 'https://course2meditation.thinkific.com/courses/everythingaboutmeditation',
    4: 'https://healing-light-master-123.thinkific.com/courses/healinglightmaster123',
    6: 'https://jordancourseonline.thinkific.com',
    7: 'https://tuniscourseonline.thinkific.com',
    8: 'https://higherawareness.thinkific.com',
  };

  return (
    <section id="courses" className="py-16" style={{
      background: 'linear-gradient(180deg, #3d1f5c 0%, #2d1a4a 100%)'
    }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            {t('coursesTitle')}
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            {t('coursesDesc')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {courses.map((course) => (
            <CourseCard 
              key={course.id} 
              course={course} 
              viewCourseText={t('viewCourse')}
              comingSoonText={t('comingSoon')}
              courseLink={courseLinks[course.id] || null}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
